import React from 'react';
import Hero from '../../components/Hero/Hero';
import Pathfinder from '../../components/Pathfinder/Pathfinder';
import Metadata from '../../components/Metadata/Metadata';
import { Box, Typography } from '@mui/material';
import Section from '../../components/Section/Section';
import Wallpaper from '../../components/Wallpaper/Wallpaper';
import Card from '../../components/Card/Card';
import GlobalCallout from '../../components/Global/CalloutDefault';
import Image from '../../components/Image/Image';
import Button from '../../components/Button/Button';

const PageContent: React.FC = () => {
  return (
    <Box>
      <Metadata
        title="Media | General Genomics"
        description="Stay informed with the latest news, press releases, and company updates from General Genomics. The Media page provides key developments and insights for industry professionals and partners."
      />
      <Hero helper="About Us" headline="Media" />

      <Section theme="" className="cards-large-icons">
        <h2 className="action-on-view action-fade-in">
          Stay Informed with General Genomics
        </h2>
        <p className="action-on-view action-fade-in">
          Explore the forefront of innovation with General Genomics by
          subscribing to our official newsletter — your primary source for news,
          insights, and thought leadership. From groundbreaking advancements in
          synthetic data with SYN46™ to real-world applications of AI for
          government, our newsletter delivers timely updates directly from the
          heart of our work. Designed for stakeholders, partners, and
          forward-thinking leaders, it offers a curated look at the milestones,
          breakthroughs, and strategic developments shaping our industry
          leadership. Stay informed, inspired, and ahead of the curve —
          subscribe now to be part of the conversation driving the future of
          data and technology.
        </p>
      </Section>

      <Section theme="dark">
        <Image
          path="/images/misc/ai-frontier-ok-tx.png"
          className="action-on-view action-fade-in show-overflow"
          alt="AI Frontier."
        />

        <Button
          url="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7290278503906729984"
          label="Subscribe"
          type="primary"
          icon="chevron_right"
          className="action-on-view action-fade-in button-size-large button-position-center"
        />
      </Section>

      <Section theme="white" className="section-cross-linking">
        <div className="card-group">
          <Card
            icon="business"
            headline="Our Industries"
            subhead="Explore how we serve various industries with our genomic expertise."
            btnURL="/industries"
            btnLabel="Learn more"
            className="action-on-view action-fade-in"
          />
          <Card
            icon="lightbulb"
            headline="Innovations"
            subhead="Stay up-to-date with the latest advancements in genomic technology."
            btnURL="/innovation"
            btnLabel="Learn more"
            className="action-on-view action-fade-in"
          />
          <Card
            icon="info"
            headline="About Us"
            subhead="Learn more about our company's vision, mission, and values."
            btnURL="/about-us"
            btnLabel="Learn more"
            className="action-on-view action-fade-in"
          />
        </div>
      </Section>

      <Wallpaper asset="../images/library/architecture-building-3.webp"></Wallpaper>

      <Section theme="dark" bgName="lines" className="section-call-to-action">
        <Typography variant="h2" className="action-on-view action-fade-in">
          Why partnering with General Genomics transforms bioinformatics
          research and innovation
        </Typography>
        <Box className="card-group">
          <Card
            icon="check"
            headline="Advanced Solutions in Analytics"
            subhead="General Genomics combines analytics and innovation with cutting-edge algorithms, large language models, machine learning, and predictive analytics to transform synthetic systems and complex data insights."
            className="action-on-view action-fade-in"
          />
          <Card
            icon="check"
            headline="Precision Insights"
            subhead="Harness predictive modeling and genomic data analysis to drive accurate, actionable insights tailored to research and healthcare objectives."
            className="action-on-view action-fade-in action-delay-250"
          />
          <Card
            icon="check"
            headline="Collaborative Expertise"
            subhead="Partner with a team experienced in supporting government initiatives to advance bioinformatics research and public health strategies."
            className="action-on-view action-fade-in action-delay-500"
          />
        </Box>
      </Section>

      <GlobalCallout />

      <Pathfinder />
    </Box>
  );
};

export default PageContent;
